import { Injectable } from '@angular/core';
import { OidcAuthService } from '../../auth/services/oidc-auth.service';

@Injectable()
export class PmaPermissionsService {

  hasPermission(permissionName: string): boolean {
    const userProfile = this.authService.getUserProfileImmediate();
    return userProfile.pmaPermissions.indexOf(permissionName) > -1;
  }


  constructor(private readonly authService: OidcAuthService) {}

}
